import React, { ReactElement } from 'react';
import Languages from '../../../../constants/Languages';

interface Props {
    activeLanguage: string;
    changeLanguage: (lang: string) => void;
}


const Language: React.FC<Props> = (props): ReactElement => {
  const { activeLanguage, changeLanguage } = props;
  return (
    <React.Fragment>
      <span className="language-link p-0" onClick={ () => activeLanguage === Languages.SR ? null : changeLanguage(Languages.SR)}>
        <span className={`list-item first-level text-uppercase language-span ${activeLanguage === Languages.SR ? 'active' : ''}`} >Srb</span>
      </span>
      <span className="language-link p-0" onClick={ () => activeLanguage === Languages.EN ?  null : changeLanguage(Languages.EN)}>
        <span className={`list-item first-level text-uppercase language-span ${activeLanguage === Languages.EN ? 'active' : ''}`} >Eng</span>
      </span>
    </React.Fragment>
  );
};

export default Language;
